import React, { ChangeEvent, useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import moment from 'moment'
import depositWithdrawService from '../../services/deposit-withdraw.service'
import ReportPageShell from '../_layout/elements/report-page-shell'
import ReportDatePicker from '../_layout/elements/report-date-picker'
import ReportPagination from '../_layout/elements/report-pagination'

const PAGE_SIZE_OPTIONS = [10, 20, 30, 40, 50]

const DepositStatement = () => {
  const location = useLocation()
  const pageTitle = location.pathname === '/withdrawstatement' ? 'Withdraw Statement' : 'Deposit Statement'
  const [depositStatement, setDepositStatement] = useState<any[]>([])
  const [filterData, setFilterData] = useState<any>({
    startDate: moment().subtract(7, 'days').toDate(),
    endDate: moment().toDate(),
    reportType: '',
  })
  const [page, setPage] = useState(1)
  const [search, setSearch] = useState('')
  const [itemsPerPage, setItemsPerPage] = useState(10)

  useEffect(() => {
    getAccountStmt()
  }, [])

  const getAccountStmt = () => {
    const type = location.pathname === '/withdrawstatement' ? 'withdraw' : 'deposit'
    depositWithdrawService
      .getDepositWithdrawLists({
        type,
        ...filterData,
        startDate: moment(filterData.startDate).format('YYYY-MM-DD'),
        endDate: moment(filterData.endDate).format('YYYY-MM-DD'),
      })
      .then((res) => {
        setDepositStatement(res?.data?.data || [])
        setPage(1)
      })
  }

  const handleformchange = (event: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFilterData({
      ...filterData,
      [event.target.name]: event.target.value,
    })
  }

  const handleSubmitform = (event: any) => {
    event.preventDefault()
    getAccountStmt()
  }

  const filteredItems = useMemo(() => {
    const q = search.trim().toLowerCase()
    if (!q) return depositStatement
    return depositStatement.filter((deposit: any) => {
      const hay = [deposit.type, deposit.amount, deposit.status, deposit.remark]
        .map((v: any) => String(v ?? '').toLowerCase())
        .join(' ')
      return hay.includes(q)
    })
  }, [depositStatement, search])

  const pageCount = Math.max(1, Math.ceil(filteredItems.length / itemsPerPage) || 1)
  const currentItems = filteredItems.slice((page - 1) * itemsPerPage, page * itemsPerPage)

  return (
    <ReportPageShell title={pageTitle}>
      <form className='row row10' method='post' onSubmit={handleSubmitform}>
        <div className='col-lg-2 col-md-3 col-6'>
          <ReportDatePicker
            selected={filterData.startDate}
            onChange={(date) => setFilterData({ ...filterData, startDate: date })}
          />
        </div>
        <div className='col-lg-2 col-md-3 col-6'>
          <ReportDatePicker
            selected={filterData.endDate}
            onChange={(date) => setFilterData({ ...filterData, endDate: date })}
          />
        </div>
        <div className='col-lg-3 col-md-4 col-12'>
          <div className='mb-2 input-group position-relative'>
            <select
              name='reportType'
              onChange={handleformchange}
              value={filterData.reportType}
              className='form-select'
            >
              <option value=''>All </option>
              <option value='approved'>Approved</option>
              <option value='pending'>Pending</option>
              <option value='rejected'>Rejected</option>
            </select>
          </div>
        </div>
        <div className='col-lg-2 col-md-2 col-12 d-grid'>
          <button type='submit' className='btn btn-primary btn-block'>
            Submit
          </button>
        </div>
      </form>
      <div className='row row10 mt-2 justify-content-between'>
        <div className='col-lg-2 col-6'>
          <div className='mb-2 input-group position-relative report-show-group'>
            <span className='me-2'>Show</span>
            <select
              className='form-select'
              value={itemsPerPage}
              onChange={(event) => {
                setItemsPerPage(Number(event.target.value) || 10)
                setPage(1)
              }}
            >
              {PAGE_SIZE_OPTIONS.map((size) => (
                <option key={size} value={size}>
                  {size}
                </option>
              ))}
            </select>
            <span className='ms-2'>Entries</span>
          </div>
        </div>
        <div className='col-lg-2 col-6'>
          <div className='mb-2 input-group position-relative report-search-group'>
            <span className='me-2'>Search:</span>
            <input
              type='search'
              className='form-control'
              placeholder={`${filteredItems.length} records...`}
              value={search}
              onChange={(event) => {
                setSearch(event.target.value)
                setPage(1)
              }}
            />
          </div>
        </div>
      </div>
      <div className='mt-2 table-responsive'>
        <table className='table table-bordered table-striped'>
          <thead>
            <tr>
              <th>Type</th>
              <th className='text-end'>Amount</th>
              <th>Date</th>
              <th>Status</th>
              <th>Remark</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.length ? (
              currentItems.map((deposit: any) => {
                const dateData = moment(deposit.createdAt).format('DD/MM/YYYY h:mm:ss A')
                return (
                  <tr key={deposit._id}>
                    <td>{deposit.type}</td>
                    <td className='text-end'>{deposit.amount}</td>
                    <td>{dateData}</td>
                    <td>{deposit.status}</td>
                    <td>{deposit.remark}</td>
                  </tr>
                )
              })
            ) : (
              <tr>
                <td colSpan={5} className='text-center'>
                  No Result Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <ReportPagination page={page} pageCount={pageCount} onPage={setPage} />
    </ReportPageShell>
  )
}

export default DepositStatement
